import React, {Component, ReactNode} from 'react'
import ResidentMeetingAttendanceForm from './ResidentMeetingAttendanceForm'
import NewMeetingAttendanceResponse from './model/NewMeetingAttendanceResponse'
import {ErrorResponseBody} from '../../network/response/ErrorResponseBody'
import {MeetingRepositoryForResident} from './MeetingRepositoryForResident'
import {NatAsyncCallFunction} from '../../__NoAutomatedTests/common/util/Natutil'
import EventEmitterExResident from '../shared/pageBaseComponents/EventEmitterExResident'
import MeetingAttendanceResponse from './model/MeetingAttendanceResponse'
import {HttpError} from '../../network/errors/HttpError'
import {ATTENDANCE_STATUS, AVAILABLE_OR_NOT} from '../../CodeMaster'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    meetingId: number
    meetingName: string
    meetingDateString: string
    meetingPlaceString: string
    proxyAttendanceAvailability: AVAILABLE_OR_NOT
    meetingAttendance: MeetingAttendanceResponse
    readOnly: boolean
    meetingRepo: MeetingRepositoryForResident
    eventEmitter: EventEmitterExResident
    navigate: NavigateFunction
    onClose: (isOk: boolean) => void
}

export default class ResidentUpdateMeetingAttendanceDialog extends Component<Props> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.handleClickSubmit = this.handleClickSubmit.bind(this)
    }

    async handleClickSubmit(meetingAttendance: NewMeetingAttendanceResponse)
        : Promise<'success' | 'communicationError' | ErrorResponseBody> {

        await this.props.eventEmitter.showLoading()
        try {
            const result = await NatAsyncCallFunction(
                this.props.meetingRepo.updateAttendance.bind(
                    this.props.meetingRepo,
                    this.props.condominiumCd,
                    this.props.meetingId,
                    this.props.meetingAttendance.attendanceId,
                    {
                        ...meetingAttendance,
                        version: this.props.meetingAttendance.version,
                    }
                ),
                this.props.navigate,
            )
            if (result === null) {
                return 'communicationError'
            }
        } catch (e) {
            return (e as HttpError).responseBody
        } finally {
            this.props.eventEmitter.closeLoading()
        }

        return 'success'
    }

    render(): ReactNode {
        return <ResidentMeetingAttendanceForm
            meetingName={this.props.meetingName}
            meetingDateString={this.props.meetingDateString}
            meetingPlaceString={this.props.meetingPlaceString}
            proxyAttendanceAvailability={this.props.proxyAttendanceAvailability}
            originalData={this.props.meetingAttendance}
            submitButtonLabel={
                this.props.meetingAttendance.attendanceStatus === ATTENDANCE_STATUS.UNANSWERED
                    ? '回答する' : '変更する'
            }
            readOnly={this.props.readOnly}
            onClose={this.props.onClose}
            onSubmit={this.handleClickSubmit}
        />
    }
}
